import * as RadixProgress from '@radix-ui/react-progress';
import * as React from 'react';
import { cn } from '../utils/cn';

export interface ProgressProps extends React.ComponentPropsWithoutRef<typeof RadixProgress.Root> {
  value: number;
  showLabel?: boolean;
}

export const Progress = React.forwardRef<React.ElementRef<typeof RadixProgress.Root>, ProgressProps>(
  ({ value, showLabel, className, ...props }, ref) => {
    const clamped = Math.max(0, Math.min(100, value));
    return (
      <div className={cn('flex flex-col gap-1.5', className)}>
        <RadixProgress.Root
          ref={ref}
          value={clamped}
          className="relative h-2 w-full overflow-hidden rounded-full bg-brand-100"
          {...props}
        >
          <RadixProgress.Indicator
            className="size-full rounded-full bg-gradient-to-r from-brand-500 to-brand-700 transition-transform duration-500 ease-out"
            style={{ transform: `translateX(-${100 - clamped}%)` }}
          />
        </RadixProgress.Root>
        {showLabel ? (
          <span className="text-xs font-medium text-[var(--color-foreground-muted)]">
            {clamped.toFixed(0)}%
          </span>
        ) : null}
      </div>
    );
  },
);
Progress.displayName = 'Progress';
